/* ============================================================================
   DRCARE-SHOP — interacción propia de colección/búsqueda/ficha de producto
   (traspaso etapa 2). NO toca assets/drcare.js: usa lo que ya existe ahí
   (window.DrToast, la delegación global de [data-add-variant] que abre el
   carro solo con el click en #drBtnOpenCart) y agrega lo que falta:
   - qty stepper + "Agregar al carro" con cantidad real de la PDP
   - combo de envío gratis (POST único con varios variant IDs)
   - servicio de armado (solo camas): agregar/quitar del carro real
   - sticky de compra mobile (leer el rect en scroll, un IntersectionObserver
     no detecta "ya pasé el botón hacia arriba")
   - acordeón de FAQ
   - drawer de filtros de colección/búsqueda (mobile)
   ============================================================================ */
(function () {
  "use strict";
  if (window.__drShopBound) return;
  window.__drShopBound = true;

  var S = window.DR_SETTINGS || {};
  var routes = S.routes || { cartAdd: "/cart/add.js", cartChange: "/cart/change.js", cart: "/cart.js" };

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function toast(msg) { if (window.DrToast) window.DrToast(msg); }
  // CLP: Shopify guarda los montos en "centavos" (×100) también en monedas sin decimales
  function clp(cents) { return "$" + Math.round((cents || 0) / 100).toLocaleString("es-CL").replace(/,/g, "."); }

  function openCartDrawer() {
    var btn = document.getElementById("drBtnOpenCart");
    if (btn) btn.click();
  }

  function cartAddOne(variantId, qty, props) {
    // `props` son propiedades de línea: viajan con el producto hasta el pedido,
    // así el cliente ve "Entrega: Preventa — llega …" en la orden sin tener que
    // acordarse de nada (19-10).
    var cuerpo = { id: variantId, quantity: qty || 1 };
    if (props) cuerpo.properties = props;
    return fetch(routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(cuerpo),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function cartAddMany(items) {
    return fetch(routes.cartAdd, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }
  function cartRemoveByVariant(variantId) {
    return fetch(routes.cartChange, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 0 }),
    });
  }

  // -------------------------------------------------------------- qty PDP --
  function initPdpQty() {
    var input = document.getElementById("qtyInput");
    if (!input) return;
    var minus = document.getElementById("qtyMinus");
    var plus = document.getElementById("qtyPlus");
    if (minus) minus.addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
    if (plus) plus.addEventListener("click", function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1);
    });
  }

  // ------------------------------------ "Ver más opiniones" + zoom de foto --
  function initReviewsMore() {
    var btn = document.querySelector("[data-reviews-more]");
    var list = document.getElementById("drReviewsList");
    if (!btn || !list) return;
    btn.addEventListener("click", function () {
      var abierto = !list.hidden;
      list.hidden = abierto;
      btn.classList.toggle("is-open", !abierto);
      btn.firstChild.nodeValue = abierto ? btn.getAttribute("data-label-cerrado") || btn.firstChild.nodeValue : "Ocultar opiniones";
      if (!abierto) { btn.setAttribute("data-label-cerrado", btn.getAttribute("data-label-cerrado") || ""); }
    });
    btn.setAttribute("data-label-cerrado", btn.firstChild.nodeValue);
  }
  // Zoom: la foto principal se abre a pantalla completa (pinch/zoom nativo en móvil,
  // clic para cerrar en escritorio). 24-09, pedido de Javiera.
  function initGalleryZoom() {
    var root = document.getElementById("pdpGallery");
    if (!root) return;
    function current() { return qs(".pdp-gallery__img.is-active", root) || qs(".pdp-gallery__img", root); }
    function open() {
      var img = current();
      if (!img) return;
      var lb = document.createElement("div");
      lb.className = "pdp-zoom";
      lb.innerHTML = '<button type="button" class="pdp-zoom__close" aria-label="Cerrar">✕</button><img src="' + (img.currentSrc || img.src).replace(/width=\d+/, "width=1600") + '" alt="">';
      document.body.appendChild(lb);
      document.body.style.overflow = "hidden";
      function close() { lb.remove(); document.body.style.overflow = ""; document.removeEventListener("keydown", esc); }
      function esc(e) { if (e.key === "Escape") close(); }
      lb.addEventListener("click", close);
      document.addEventListener("keydown", esc);
    }
    var zb = qs("[data-gallery-zoom]", root);
    if (zb) zb.addEventListener("click", open);
    var track = document.getElementById("pdpGalleryTrack");
    if (track) track.addEventListener("click", open);
  }

  // -------------------------------------------------- variantes (PDP) -----
  // 24-09-2026: la ficha no tenía selector de variantes (venía de la maqueta, con un solo SKU por
  // producto). Resuelve la variante cruzando SOLO las opciones visibles (el catálogo trae opciones
  // duplicadas "Talla"/"Size" y opciones de un solo valor) y actualiza precio, cuotas, ahorro, SKU,
  // stock, envío gratis, botones y la URL, sin recargar.
  function initPdpVariants() {
    var box = document.getElementById("pdpVariants");
    var raw = document.getElementById("pdpVariantData");
    if (!box || !raw) return;
    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;
    var shown = data.shown || [];
    var groups = qsa(".pdp-variant", box);
    var hint = document.getElementById("pdpVariantHint");
    var addBtn = document.getElementById("btnAddToCart");
    var stickyBtn = document.querySelector("[data-sticky-add]");
    var stickyPrice = document.querySelector(".pdp-sticky-atc .p");
    var nCuotas = parseInt(data.cuotas, 10) || 6;

    function selected() {
      return groups.map(function (g) {
        var on = qs(".pdp-variant__opt.is-active", g);
        return { idx: parseInt(g.getAttribute("data-option-index"), 10), val: on ? on.getAttribute("data-value") : null };
      });
    }
    function match(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < sel.length; j++) {
          if (sel[j].val !== null && v.options[sel[j].idx] !== sel[j].val) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }
    function existsWith(idx, val, sel) {
      var probe = sel.map(function (s) { return s.idx === idx ? { idx: idx, val: val } : s; });
      var v = match(probe);
      return v ? v.available : false;
    }
    function paintAvailability() {
      var sel = selected();
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute("data-option-index"), 10);
        // para juzgar una opción, se ignora la selección de ESA opción y se respetan las demás
        var others = sel.filter(function (s) { return s.idx !== idx; });
        qsa(".pdp-variant__opt", g).forEach(function (b) {
          var val = b.getAttribute("data-value");
          var probe = others.concat([{ idx: idx, val: val }]);
          var v = match(probe);
          b.classList.toggle("is-unavailable", !v || !v.available);
        });
      });
    }
    function apply(v, push) {
      var elPrice = document.getElementById("pdpPrice");
      var elBefore = document.getElementById("pdpBefore");
      var elSave = document.getElementById("pdpSavings");
      var elCuotas = document.getElementById("pdpCuotas");
      var elSku = document.getElementById("pdpSku");
      var elStock = document.getElementById("pdpStock");
      var elShip = document.getElementById("pdpShipFree");
      if (elPrice) elPrice.textContent = clp(v.price);
      var hasBefore = v.compare && v.compare > v.price;
      if (elBefore) { elBefore.textContent = hasBefore ? clp(v.compare) : ""; elBefore.hidden = !hasBefore; }
      if (elSave) {
        var pct = hasBefore ? Math.round((1 - v.price / v.compare) * 100) : 0;
        var show = hasBefore && pct >= 15 && pct <= 55;
        elSave.textContent = show ? "Ahorras " + clp(v.compare - v.price) : "";
        elSave.hidden = !show;
      }
      if (elCuotas) {
        // misma fórmula que el Liquid: ceil(precio / n / 1000) * 1000, en "centavos"
        var cuota = Math.ceil(v.price / nCuotas / 1000) * 1000;
        var suf = qs("span", elCuotas);
        elCuotas.textContent = nCuotas + "x " + clp(cuota) + " sin interés";
        if (suf) { elCuotas.appendChild(document.createTextNode(" ")); elCuotas.appendChild(suf); }
        elCuotas.hidden = !v.available;
      }
      if (elSku) { qs("span", elSku).textContent = v.sku || ""; elSku.hidden = !v.sku; }
      // 19-10 — Preventa por VARIANTE: la etiqueta la pone el cliente al producto, pero
      // reservar o comprar depende del stock de la variante elegida. Sin esto, apply()
      // corre al cargar la página y le reescribía "Llega el 29 de octubre" por
      // "Disponible" y "Reservar ahora" por "Agregar al carro": la ficha quedaba
      // prometiendo despacho inmediato de algo que está en camino.
      // Ojo: con CONTINUE puesto, v.available es true igual sin stock; el stock real
      // se lee de v.qty y solo vale si la variante tiene inventario gestionado.
      var pv = !!data.preventa && v.tracked && v.qty <= 0;
      var pvProp = pv ? (data.pvLlega ? "Preventa — llega " + data.pvLlega : "Preventa — por encargo") : null;
      if (elStock) {
        elStock.classList.remove("is-out", "is-low", "is-preventa");
        if (pv) { elStock.textContent = data.pvLlega ? "Llega " + data.pvLlega : "Por encargo"; elStock.classList.add("is-preventa"); }
        else if (!v.available) { elStock.textContent = "Sin stock por ahora"; elStock.classList.add("is-out"); }
        else if (v.tracked && v.qty > 0 && v.qty <= (data.stockMax || 0)) { elStock.textContent = "Quedan " + v.qty; elStock.classList.add("is-low"); }
        else { elStock.textContent = "Disponible"; }
      }
      if (elShip) elShip.hidden = !(data.umbral > 0 && v.price >= data.umbral && v.available);
      [addBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.setAttribute("data-variant-id", v.id);
        b.disabled = !v.available;
        if (pvProp) b.setAttribute("data-preventa", pvProp);
        else b.removeAttribute("data-preventa");
        if (b === addBtn) b.textContent = pv ? "Reservar ahora" : (v.available ? "Agregar al carro" : "Sin stock por ahora");
        if (b === stickyBtn) b.textContent = pv ? "Reservar ahora" : (v.available ? "Agregar al carro" : "Sin stock por ahora");
      });
      if (stickyPrice) stickyPrice.textContent = clp(v.price);
      // foto de la variante, si tiene una propia
      if (v.imageId) {
        var img = document.querySelector('.pdp-gallery__img[data-media-id="' + v.imageId + '"]');
        if (img) {
          var thumb = document.querySelector('.pdp-gallery__thumb[data-index="' + img.getAttribute("data-index") + '"]');
          if (thumb) thumb.click();
        }
      }
      if (push && window.history && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u.toString());
      }
    }
    box.addEventListener("click", function (e) {
      var btn = e.target.closest(".pdp-variant__opt");
      if (!btn) return;
      var group = btn.closest(".pdp-variant");
      qsa(".pdp-variant__opt", group).forEach(function (b) { b.classList.remove("is-active"); b.setAttribute("aria-checked", "false"); });
      btn.classList.add("is-active");
      btn.setAttribute("aria-checked", "true");
      var v = match(selected());
      if (!v) {
        // la combinación no existe: se deja elegida la opción y se busca la primera variante que la tenga
        var idx = parseInt(btn.getAttribute("data-option-index"), 10);
        v = match([{ idx: idx, val: btn.getAttribute("data-value") }]);
        if (v) {
          groups.forEach(function (g) {
            var gi = parseInt(g.getAttribute("data-option-index"), 10);
            qsa(".pdp-variant__opt", g).forEach(function (b) {
              var on = b.getAttribute("data-value") === v.options[gi];
              b.classList.toggle("is-active", on);
              b.setAttribute("aria-checked", on ? "true" : "false");
            });
          });
        }
      }
      if (hint) hint.hidden = !!v;
      if (v) apply(v, true);
      paintAvailability();
    });
    // estado inicial: respeta ?variant= y deja marcada la variante que el servidor ya pintó
    var params = new URLSearchParams(location.search);
    var wanted = params.get("variant");
    var start = null;
    if (wanted) { start = variants.filter(function (v) { return String(v.id) === String(wanted); })[0] || null; }
    if (!start && addBtn) { start = variants.filter(function (v) { return String(v.id) === addBtn.getAttribute("data-variant-id"); })[0] || null; }
    if (start) {
      groups.forEach(function (g) {
        var gi = parseInt(g.getAttribute("data-option-index"), 10);
        qsa(".pdp-variant__opt", g).forEach(function (b) {
          var on = b.getAttribute("data-value") === start.options[gi];
          b.classList.toggle("is-active", on);
          b.setAttribute("aria-checked", on ? "true" : "false");
        });
      });
      apply(start, false);
    }
    paintAvailability();
  }

  // ---------------------------------------------------- add to cart (PDP) --
  function initPdpAddToCart() {
    var btn = document.getElementById("btnAddToCart");
    var stickyBtn = document.querySelector("[data-sticky-add]");
    if (!btn && !stickyBtn) return;
    function add() {
      var variantId = (btn && btn.getAttribute("data-variant-id")) || (stickyBtn && stickyBtn.getAttribute("data-variant-id"));
      if (!variantId) return;
      var input = document.getElementById("qtyInput");
      var qty = input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
      var target = btn || stickyBtn;
      // la marca puede estar en el botón principal o en el de la barra pegada
      var pv = (btn && btn.getAttribute("data-preventa")) || (stickyBtn && stickyBtn.getAttribute("data-preventa"));
      target.disabled = true;
      cartAddOne(variantId, qty, pv ? { Entrega: pv } : null)
        .then(function () { toast(pv ? "Reservado — queda en tu carro" : (qty > 1 ? "Agregados al carro" : "Agregado al carro")); openCartDrawer(); })
        .catch(function () { toast("No pudimos agregarlo — revisa el stock"); })
        .then(function () { target.disabled = false; });
    }
    if (btn) btn.addEventListener("click", add);
    if (stickyBtn) stickyBtn.addEventListener("click", add);
  }

  // ------------------------------------------------- combo envío gratis ----
  function initShippingCombo() {
    document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-add-variants]");
      if (!btn) return;
      if (e.drComboHandled) return; // ya lo procesó el handler global de drcare.js
      e.drComboHandled = true;
      e.preventDefault();
      var raw = btn.getAttribute("data-add-variants") || "";
      var ids = raw.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return;
      btn.disabled = true;
      cartAddMany(ids.map(function (id) { return { id: id, quantity: 1 }; }))
        .then(function () { toast("Agregados al carro"); openCartDrawer(); })
        .catch(function () { toast("No pudimos agregarlos — revisa el stock"); })
        .then(function () { btn.disabled = false; });
    });
  }

  // ------------------------------------------------------- sticky ATC -----
  function initStickyAtc() {
    var bar = document.querySelector(".pdp-sticky-atc");
    var btn = document.getElementById("btnAddToCart");
    var footer = document.querySelector(".site-footer");
    if (!bar || !btn) return;
    function check() {
      var r = btn.getBoundingClientRect();
      var footerVisible = footer ? footer.getBoundingClientRect().top < window.innerHeight : false;
      var visible = r.bottom < 0 && !footerVisible;
      bar.classList.toggle("is-visible", visible);
      document.body.classList.toggle("has-sticky-atc", visible);
    }
    addEventListener("scroll", function () { requestAnimationFrame(check); }, { passive: true });
    check();
  }

  // --------------------------------------------- servicio de armado -------
  function initArmado() {
    var chk = document.getElementById("chkArmado");
    if (!chk) return;
    chk.addEventListener("change", function () {
      var variantId = chk.getAttribute("data-variant-id");
      if (!variantId) return;
      chk.disabled = true;
      var op = chk.checked ? cartAddOne(variantId, 1) : cartRemoveByVariant(variantId);
      op.then(function () {
        toast(chk.checked ? "Servicio de armado agregado" : "Servicio de armado quitado");
        openCartDrawer();
      }).catch(function () {
        toast("No pudimos actualizar el servicio de armado");
        chk.checked = !chk.checked;
      }).then(function () { chk.disabled = false; });
    });
  }

  // -------------------------------------------------------------- FAQ -----
  function initFaqAccordion() {
    document.addEventListener("click", function (e) {
      var q = e.target.closest(".faq-item__q");
      if (!q) return;
      var item = q.closest(".faq-item");
      if (item) {
        var open = item.classList.toggle("is-open");
        q.setAttribute("aria-expanded", open ? "true" : "false");
      }
    });
  }

  // --------------------------------------------- drawer de filtros --------
  function initFiltersDrawer() {
    document.addEventListener("click", function (e) {
      if (e.target.closest("#filtersToggle")) {
        var f = document.querySelector(".filters");
        var s = document.getElementById("filtersScrim");
        if (f) f.classList.add("is-open");
        if (s) s.classList.add("is-open");
      }
      if (e.target.closest("#filtersClose") || e.target.closest("#filtersScrim")) {
        var f2 = document.querySelector(".filters");
        var s2 = document.getElementById("filtersScrim");
        if (f2) f2.classList.remove("is-open");
        if (s2) s2.classList.remove("is-open");
      }
    });
  }

  // ------------------------------------------ filtros en vivo (colección) --
  // Igual que la maqueta (js/collection.js): cambiar un filtro u orden
  // re-pinta la grilla SIN recargar. Se pide la misma sección por la Section
  // Rendering API con la URL de filtros de Shopify y se reemplaza
  // #drCollectionMain; la URL se actualiza con pushState para compartir.
  function initLiveFilters() {
    if (!document.getElementById("drCollectionMain")) return;
    function buildUrl() {
      var main = document.getElementById("drCollectionMain");
      var form = document.getElementById("drFiltersForm");
      var params = new URLSearchParams();
      if (form) {
        var buckets = Array.prototype.slice.call(form.querySelectorAll("[data-price-bucket]:checked"));
        if (buckets.length) {
          var mins = buckets.map(function (b) { return parseInt(b.getAttribute("data-min"), 10) || 0; });
          var maxes = buckets.map(function (b) { return parseInt(b.getAttribute("data-max"), 10) || 0; });
          var min = Math.min.apply(null, mins);
          var max = maxes.indexOf(0) !== -1 ? 0 : Math.max.apply(null, maxes);
          var gte = form.querySelector("[data-price-gte]");
          var lte = form.querySelector("[data-price-lte]");
          if (gte && min > 0) params.append(gte.name, String(min));
          if (lte && max > 0) params.append(lte.name, String(max - 1));
        }
        Array.prototype.forEach.call(form.querySelectorAll("input[name]"), function (i) {
          if (i.type === "hidden") return;
          if ((i.type === "checkbox" || i.type === "radio") && i.checked && i.value !== "") params.append(i.name, i.value);
        });
      }
      var sort = document.getElementById("drSortSelect");
      if (sort && sort.value && sort.value !== sort.getAttribute("data-default")) params.append("sort_by", sort.value);
      var q = params.toString();
      return main.getAttribute("data-url") + (q ? "?" + q : "");
    }
    function load(url, push) {
      var main = document.getElementById("drCollectionMain");
      if (!main) return Promise.resolve();
      var sid = main.getAttribute("data-section-id");
      main.style.opacity = ".55";
      var sep = url.indexOf("?") > -1 ? "&" : "?";
      return fetch(url + sep + "sections=" + encodeURIComponent(sid), { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error("http"); return r.json(); })
        .then(function (j) {
          var html = j[sid];
          if (!html) throw new Error("sin seccion");
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          var fresh = tmp.querySelector("#drCollectionMain");
          if (!fresh) throw new Error("sin main");
          main.replaceWith(fresh);
          var scrim = document.getElementById("filtersScrim");
          if (scrim) scrim.classList.remove("is-open");
          if (push) history.pushState({ drColl: true }, "", url);
        })
        .catch(function () { window.location.href = url; });
    }
    document.addEventListener("change", function (e) {
      if (e.target.closest("#drFiltersForm") || e.target.id === "drSortSelect") load(buildUrl(), true);
    });
    document.addEventListener("click", function (e) {
      var clear = e.target.closest("#btnClearFilters, #btnClearFilters2");
      if (!clear) return;
      e.preventDefault();
      var main = document.getElementById("drCollectionMain");
      if (main) load(main.getAttribute("data-url"), true);
    });
    window.addEventListener("popstate", function () {
      if (document.getElementById("drCollectionMain")) load(location.pathname + location.search, false);
    });
  }

  // ----------------------------------------------------- pack armable -----
  // El pack (ant-pack__it, complementos con checkbox) recalcula total/ahorro
  // en el cliente y agrega todo junto con un solo click — sin recargar la
  // página (los complementos ya vienen filtrados y escalados en precio desde
  // Liquid, acá solo se decide cuáles quedan marcados).
  function initPack() {
    var box = document.getElementById("pdpPack");
    if (!box) return;
    var mainPrice = parseInt(box.getAttribute("data-main-price") || "0", 10);
    var discountPct = parseFloat(box.getAttribute("data-discount") || "0");
    function recalc() {
      var checks = qsa('[data-ant-pack]', box);
      var sum = 0;
      checks.forEach(function (c) { if (c.checked) sum += parseInt(c.getAttribute("data-price"), 10) || 0; });
      // El descuento real de Shopify es sobre todo el pedido con 2+ productos:
      // sin complementos marcados no hay ahorro. Redondeo mitad-abajo como Shopify.
      var ahorro = sum > 0 ? Math.ceil((mainPrice + sum) * discountPct - 0.5) : 0;
      var total = mainPrice + sum - ahorro;
      var totEl = qs(".ant-pack__tot b", box);
      var ahorroEl = qs(".ant-pack__ahorro", box);
      var countEl = qs(".ant-pack__tot span", box);
      if (totEl) totEl.textContent = "$" + Math.round(total).toLocaleString("es-CL");
      if (countEl) countEl.textContent = "Total del pack (" + (checks.filter(function(c){return c.checked;}).length + 1) + " productos)";
      if (ahorroEl) {
        if (ahorro > 0) { ahorroEl.hidden = false; ahorroEl.textContent = "Ahorras $" + Math.round(ahorro).toLocaleString("es-CL") + ": el " + Math.round(discountPct * 100) + " % se descuenta solo en el carro al llevar 2 o más productos"; }
        else ahorroEl.hidden = true;
      }
    }
    box.addEventListener("change", function (e) {
      if (!e.target.matches("[data-ant-pack]")) return;
      var it = e.target.closest(".ant-pack__it");
      if (it) it.classList.toggle("on", e.target.checked);
      recalc();
    });
    var addAllBtn = qs(".ant-btn-pack", box);
    if (addAllBtn) addAllBtn.addEventListener("click", function () {
      var ids = [{ id: box.getAttribute("data-main-variant"), quantity: 1 }];
      qsa('[data-ant-pack]:checked', box).forEach(function (c) { ids.push({ id: c.getAttribute("data-variant"), quantity: 1 }); });
      addAllBtn.disabled = true;
      cartAddMany(ids)
        .then(function () { toast("Pack agregado al carro"); openCartDrawer(); })
        .catch(function () { toast("No pudimos agregar el pack completo"); })
        .then(function () { addAllBtn.disabled = false; });
    });
  }

  // -------------------------- pack en móvil: después de la ficha técnica --
  // 17-09 (Javiera): en celular el pack empujaba la ficha técnica muy abajo.
  function initPackPlacement() {
    var pack = document.getElementById("pdpPack"), ficha = document.getElementById("ficha");
    if (!pack || !ficha) return;
    if (!(window.matchMedia && window.matchMedia("(max-width: 900px)").matches)) return;
    var sec = document.createElement("section"); sec.className = "pdp-section pdp-section--pack";
    sec.appendChild(pack); ficha.insertAdjacentElement("afterend", sec);
  }

  // ------------------------------- barra de envío de la ficha: recalcular --
  // Liquid la calcula con cart.total_price + este producto al cargar la página;
  // tras agregar por AJAX quedaba con el faltante viejo. Se pide la sección
  // principal fresca por la Section Rendering API y se reemplaza solo la barra.
  function initShippingBarRefresh() {
    var bar = document.getElementById("pdpShippingBar");
    if (!bar) return;
    var sec = bar.closest('[id^="shopify-section-"]');
    if (!sec) return;
    var sid = sec.id.replace("shopify-section-", "");
    var busy = false, again = false;
    function refresh() {
      if (busy) { again = true; return; }
      busy = true;
      var url = window.location.pathname + "?sections=" + encodeURIComponent(sid);
      fetch(url, { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j && j[sid]; if (!html) return;
          var tmp = document.createElement("div"); tmp.innerHTML = html;
          var fresh = tmp.querySelector("#pdpShippingBar");
          var cur = document.getElementById("pdpShippingBar");
          if (fresh && cur) cur.replaceWith(fresh);
        })
        .catch(function () {})
        .then(function () { busy = false; if (again) { again = false; refresh(); } });
    }
    document.addEventListener("cart:updated", refresh);
  }

  // ------------------------------------------------------- galería de fotos --
  // Todas las fotos del producto: miniaturas, flechas, teclado y swipe (16-09).
  function initGallery() {
    var root = document.getElementById("pdpGallery");
    if (!root) return;
    var imgs = qsa(".pdp-gallery__img", root);
    if (imgs.length < 2) return;
    var thumbs = qsa(".pdp-gallery__thumb", root);
    var count = document.getElementById("pdpGalleryCount");
    var main = qs(".pdp-gallery__main", root);
    var cur = 0;
    function go(i) {
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle("is-active", k === cur); });
      thumbs.forEach(function (t, k) { t.classList.toggle("is-active", k === cur); t.setAttribute("aria-selected", k === cur ? "true" : "false"); });
      if (thumbs[cur] && thumbs[cur].scrollIntoView) thumbs[cur].scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      if (count) count.textContent = (cur + 1) + " / " + imgs.length;
    }
    thumbs.forEach(function (t) { t.addEventListener("click", function () { go(parseInt(t.getAttribute("data-index"), 10) || 0); }); });
    var prev = qs("[data-gallery-prev]", root), next = qs("[data-gallery-next]", root);
    if (prev) prev.addEventListener("click", function () { go(cur - 1); });
    if (next) next.addEventListener("click", function () { go(cur + 1); });
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { go(cur - 1); e.preventDefault(); }
      if (e.key === "ArrowRight") { go(cur + 1); e.preventDefault(); }
    });
    // swipe: 40 px, más horizontal que vertical (mismo criterio que el hero)
    var sx = 0, sy = 0, swiping = false;
    main.addEventListener("touchstart", function (e) { var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiping = true; }, { passive: true });
    main.addEventListener("touchend", function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0]; var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? cur + 1 : cur - 1);
    }, { passive: true });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initGallery();
    initPackPlacement();
    initShippingBarRefresh();
    initPdpQty();
    initPdpVariants();
    initReviewsMore();
    initGalleryZoom();
    initPdpAddToCart();
    initShippingCombo();
    initStickyAtc();
    initArmado();
    initFaqAccordion();
    initFiltersDrawer();
    initLiveFilters();
    initPack();
  });
})();
